import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Button from "@material-ui/core/Button";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core";
import { Autocomplete } from "@mui/material";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
// import Autocomplete, {
// 	createFilterOptions,
// } from "@material-ui/lab/Autocomplete";
// import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import useQueuesFunil from "../../hooks/useQueuesFunil";
import useTags from "../../hooks/useTags";
import TicketTagsLead from "../TicketTagsLead";
import useFiliais from "../../hooks/useFiliais";
import Ticket from "../Ticket";
import { BotaoCancelar, BotaoConfirmar } from "../BotoesModal";
import { agendamentoParaEnvio, paraCampoDateTime, temCampoAgendamento }
	from "../../helpers/agendamentoLead";

// const useStyles = makeStyles((theme) => ({
// 	maxWidth: {
// 		width: "100%",
// 	},
// }));

// const filterOptions = createFilterOptions({
// 	trim: true,
// });

const useStyles = makeStyles((theme) => ({
	maxWidth: {
		width: '100%',
	},
	marginTop: {
		marginTop: theme.spacing(2), // Ajuste o valor conforme necessário
	},
}));

// const TransferTicketModal = ({ modalOpen, onClose, ticketid }) => {
// isGroup = modo "Alterar grupo": grupo não tem lead, então a modal fica só com
// nome, etiqueta e observações (sem filial, etapa e agendamento, que são campos
// de lead) e o salvamento não passa pelo ERP — ver TicketController.updateEtapa.
const TransferTicketModal = ({ modalOpen, onClose, ticketid, isGroup, userId, leadId, funil_icode, obs, nomeT, agenda, etapa, tag, filialIdTicket }) => {
	const history = useHistory();
	// const [options, setOptions] = useState([]);
	const [queues, setQueues] = useState([]);
	// const [allQueues, setAllQueues] = useState([]);
	const [filiais, setFiliais] = useState([]);
	const { findAll: findFiliais } = useFiliais(leadId);
	const [filial, setFilial] = useState(null);
	const [loading, setLoading] = useState(false);
	const [searchParam, setSearchParam] = useState('');
	const [selectedUser, setSelectedUser] = useState(null);
	const [selectedQueue, setSelectedQueue] = useState('');
	const classes = useStyles();
	const { findAll: findAllQueues } = useQueuesFunil(userId, funil_icode, ticketid);
	const [agendamento, setAgendamento] = useState('');
	const [observacao, setObservacao] = useState('');
	const [nome, setNome] = useState('');

	const [tags, setTags] = useState([]);
	// const [allTags, setAllTags] = useState([]);
	const [selectedTag, setSelectedTag] = useState('');
	const { findAll: findAllTags } = useTags("atribuir");

	const mostraAgendamento = temCampoAgendamento(isGroup);

	// Tag do CRM (ERP), outra coisa que a etiqueta acima: tem lista própria e remoção,
	// então mora num modal separado em vez de mais um campo aqui. Grupo não tem lead.
	const [tagsLeadModalOpen, setTagsLeadModalOpen] = useState(false);

	const init = async () => {
		setObservacao(obs || '');
		setNome(nomeT || '');

		const listTags = await findAllTags();
		// setAllTags(listTags);
		setTags(listTags);
		setSelectedTag(listTags.some(t => t.id === tag) ? tag : '');

		// Grupo: etapa, agendamento e filial não existem (são do lead), então nem
		// busca as listas — as duas chamadas iriam ao ERP com leadId/funil nulos.
		if (isGroup) return;

		console.log("ID DO FUNIL: " + funil_icode);

		const list = await findAllQueues(userId, funil_icode);
		// setAllQueues(list);
		setQueues(list);
		setAgendamento(paraCampoDateTime(agenda || ''));
		setSelectedQueue(etapa);

		const listFiliais = await findFiliais(leadId);
		setFiliais(listFiliais);
		setFilial(filialIdTicket);
	}

	useEffect(() => {
		init();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		init();
	}, [funil_icode]);

	// O modal fica montado com a conversa: sem reler ao abrir, ele devolvia ao ERP o agendamento e as
	// observações de quando a conversa foi aberta, desfazendo o que o ERP (ou o carrinho) gravou depois.
	useEffect(() => {
		if (modalOpen) init();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modalOpen]);

	// useEffect(() => {
	// 	if (!modalOpen || searchParam.length < 3) {
	// 		setLoading(false);
	// 		return;
	// 	}
	// 	setLoading(true);
	// 	const delayDebounceFn = setTimeout(() => {
	// 		const fetchUsers = async () => {
	// 			try {
	// 				const { data } = await api.get("/users/", {
	// 					params: { searchParam },
	// 				});
	// 				setOptions(data.users);
	// 				setLoading(false);
	// 			} catch (err) {
	// 				setLoading(false);
	// 				toastError(err);
	// 			}
	// 		};

	// 		fetchUsers();
	// 	}, 500);
	// 	return () => clearTimeout(delayDebounceFn);
	// }, [searchParam, modalOpen]);

	const handleClose = () => {
		onClose();
		setSearchParam("");
		setSelectedUser(null);
	};

	const handleSaveTicket = async e => {
		e.preventDefault();
		if (!ticketid) return;
		setLoading(true);
		try {
			let data = {};

			// if (selectedUser) {
			// 	data.userId = selectedUser.id
			// }

			// Grupo: só os campos locais. O backend detecta o ticket de grupo e
			// grava sem chamar o ERP (UpdateTicketGrupo).
			if (isGroup) {
				data.name = nome;
				data.observacao = observacao;
				data.tagId = selectedTag || null;
			} else if (selectedQueue && selectedQueue !== null) {
				data.queueId = selectedQueue
				data.userId = userId;
				data.leadId = leadId;
				data.observacao = observacao;
				data.name = nome;
				data.filialId = filial;
				if (selectedTag) {
					data.tagId = selectedTag;
				}
				if (mostraAgendamento) {
					data.agendamento = agendamentoParaEnvio(agendamento);
				}
				// if (!selectedUser) {
				// 	data.status = 'pending';
				// 	data.userId = null;
				// }
			}
			await api.put(`/ticketsetapa/${ticketid}`, data);

			setLoading(false);
			handleClose();
			history.push(`/tickets/${ticketid}`);
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	const handleChange = (event, newValue) => {
		setFilial(newValue?.id);
	};

	return (
		<>
		<Dialog open={modalOpen} onClose={handleClose} fullWidth maxWidth="md" scroll="paper">
			<form onSubmit={handleSaveTicket}>
				<DialogTitle id="form-dialog-title">
					{isGroup
						? i18n.t("transferTicketModal.titleGroup")
						: i18n.t("transferTicketModal.title")}
				</DialogTitle>
				<DialogContent dividers>
					{/*<Autocomplete
						style={{ width: 300, marginBottom: 20 }}
						getOptionLabel={option => `${option.name}`}
						onChange={(e, newValue) => {
							setSelectedUser(newValue);
							if (newValue != null && Array.isArray(newValue.queues)) {
								setQueues(newValue.queues);
							} else {
								setQueues(allQueues);
								setSelectedQueue('');
							}
						}}
						options={options}
						filterOptions={filterOptions}
						freeSolo
						autoHighlight
						noOptionsText={i18n.t("transferTicketModal.noOptions")}
						loading={loading}
						renderInput={params => (
							<TextField
								{...params}
								label={i18n.t("transferTicketModal.fieldLabel")}
								variant="outlined"
								required
								autoFocus
								onChange={e => setSearchParam(e.target.value)}
								InputProps={{
									...params.InputProps,
									endAdornment: (
										<React.Fragment>
											{loading ? (
												<CircularProgress color="inherit" size={20} />
											) : null}
											{params.InputProps.endAdornment}
										</React.Fragment>
									),
								}}
							/>
						)}
					/>*/}
					{!isGroup && filiais && filiais.length>0 && (<FormControl variant="outlined" className={classes.maxWidth}>
						<Autocomplete
							options={filiais}
							getOptionLabel={(option) => option.nome}
							value={filiais.find((option) => option.id === filial) || null}
							onChange={handleChange}
							sx={{
								fontSize: '0.85rem',
								'& .MuiAutocomplete-inputRoot': {
									padding: '4px !important',
									fontSize: '0.85rem',
								},
							}}
							renderOption={(props, option) => (
								<MenuItem
									{...props}
									dense
									sx={{
										fontSize: '0.85rem',
										minHeight: '32px',
										paddingY: 0.5,
									}}
								>
									{option.nome}
								</MenuItem>
							)}
							renderInput={(params) => (
								<TextField
									{...params}
									label="Filial"
									variant="outlined"
									margin="dense"
									sx={{
										'& input': {
											fontSize: '0.85rem',
										},
										'& label': {
											fontSize: '0.85rem',
										},
									}}
								/>
							)}
						/>
					</FormControl>)}
					<FormControl variant="outlined" className={classes.maxWidth}>
						<TextField
							label={isGroup ? "Nome do grupo" : "Nome do lead"}
							variant="outlined"
							multiline
							fullWidth
							className={classes.marginTop}
							value={nome}
							onChange={(e) => setNome(e.target.value)}
						/>
					</FormControl>
					<FormControl variant="outlined" className={`${classes.maxWidth} ${classes.marginTop}`}>
						<InputLabel>Incluir etiqueta</InputLabel>
						<Select
							value={selectedTag}
							onChange={(e) => setSelectedTag(e.target.value)}
							label="Incluir etiqueta"
						>
							<MenuItem value={''}>&nbsp;</MenuItem>
							{tags.map((tag) => (
								<MenuItem key={tag.id} value={tag.id}>{tag.descricao}</MenuItem>
							))}
						</Select>
					</FormControl>
					{!isGroup && (
						<FormControl variant="outlined" className={`${classes.maxWidth} ${classes.marginTop}`}>
							<InputLabel>Etapa do lead</InputLabel>
							<Select
								value={selectedQueue}
								onChange={(e) => setSelectedQueue(e.target.value)}
								label="Etapa do lead"
							>
								{/* <MenuItem value={''}>&nbsp;</MenuItem> */}
								{queues.map((queue) => (
									<MenuItem key={queue.id} value={queue.id}>{queue.name}</MenuItem>
								))}
							</Select>
						</FormControl>
					)}
					{mostraAgendamento && (
						<FormControl variant="outlined" className={`${classes.maxWidth} ${classes.marginTop}`}>
							<TextField
								label="Data de agendamento"
								variant="outlined"
								type="datetime-local"
								fullWidth
								InputLabelProps={{ shrink: true }}
								className={classes.marginTop}
								value={agendamento}
								onChange={(e) => setAgendamento(e.target.value)}
							/>
						</FormControl>
					)}
					{!isGroup && (
						<Button
							variant="outlined"
							fullWidth
							startIcon={<LocalOfferIcon />}
							className={classes.marginTop}
							onClick={() => setTagsLeadModalOpen(true)}
						>
							Tags do lead
						</Button>
					)}
					<FormControl variant="outlined" className={`${classes.maxWidth} ${classes.marginTop}`}>
						<TextField
							label="Observações"
							variant="outlined"
							multiline
							fullWidth
							className={classes.marginTop}
							value={observacao}
							onChange={(e) => setObservacao(e.target.value)}
						/>
					</FormControl>
				</DialogContent>
				<DialogActions>
					<BotaoCancelar onClick={handleClose} disabled={loading}>
						{i18n.t("transferTicketModal.buttons.cancel")}
					</BotaoCancelar>
					<BotaoConfirmar type="submit" loading={loading}>
						{i18n.t("transferTicketModal.buttons.ok")}
					</BotaoConfirmar>
				</DialogActions>
			</form>
		</Dialog>
		{!isGroup && (
			<TicketTagsLead
				modalOpen={tagsLeadModalOpen}
				onClose={() => setTagsLeadModalOpen(false)}
				leadId={leadId}
			/>
		)}
		</>
	);
};

export default TransferTicketModal;
